import { render, staticRenderFns } from "./FormBlock.vue?vue&type=template&id=521f1319&scoped=true&"
import script from "./FormBlock.vue?vue&type=script&lang=js&"
export * from "./FormBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521f1319",
  null
  
)

export default component.exports